import React from "react";
import AdvancedManagementPill from "./AdvancedManagementPill";
import Select from "../../../../../shared/Select/Select";

const AdvancedManagementFilter = props => {
	const arrayTypes = [
		{ label: "Todos", value: 0 },
		{
			label: "Ativos",
			value: "A",
			class: "__active",
			results: props.dataRelationship.filter(dr => dr.status.status === "A").length
		},
		{
			label: "Em Análise",
			value: "P",
			class: "__analysis",
			results: props.dataRelationship.filter(dr => dr.status.status === "P").length
		},
		{
			label: "Em Negociação",
			value: "N",
			class: "__negotiation",
			results: props.dataRelationship.filter(dr => dr.status.status === "N").length
		},
		{
			label: "Inativos",
			value: "I",
			class: "__inactive",
			results: props.dataRelationship.filter(dr => dr.status.status === "I").length
		}
	];

	let handleClick = item => {
		if (props.filteredStatements.value === item.value) {
			props.changeFilter({
				label: "Todos",
				value: 0
			});
		} else {
			props.changeFilter({
				label: item.label,
				value: item.value
			});
		}
	};

	return !props.isMobile && !props.isTablet ? (
		<AdvancedManagementPill
			arrayTypes={arrayTypes}
			handleClick={handleClick}
			status={props.filteredStatements.value}
			changeFilter={props.changeFilter}
		/>
	) : (
		<Select
			selected={props.filteredStatements}
			onChange={item => {
				handleClick(item);
			}}
			options={arrayTypes.filter(item => item.value === 0 || item.results > 0)}
		/>
	);
};

export default AdvancedManagementFilter;
